import React from "react";
import * as Icons from "lucide-react";

export default function Icon({ name, ...props }) {
  const Cmp = Icons[name] || Icons.Square;
  return <Cmp {...props} />;
}
